<template lang="pug">
  validation-observer(ref='conflito', tag='div')
    el-card
      el-row(:gutter="20")
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Número do Processo:
          span.info-label {{conflito.numeroProcesso}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Município:
          span.info-label {{conflito.municipio ? conflito.municipio.nome : '-'}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Número de Famílias:
          span.info-label {{conflito.numeroFamilias}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Jurisdição:
          span.info-label {{conflito.jurisdicoFormatada}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Data de Cadastro:
          span.info-label {{conflito.dataCriacaoFormatada}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Origem:
          span.info-label {{conflito.origemFormatada}}
    el-card.top-margin
      el-row.marginLeft
        el-col(:span="24")
          app-divider(
            label="Área com conflito",
            :showBorder="true",
            required
          )
        el-col(:span="24")
          validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="Área com conflito")
            p.margin-titulo Observação
            el-input.input(v-model="conflito.observacao", type="textarea", :rows="4", :class="{'erro' : errors.length}")
            span.help.erro {{ errors[0] }}
        el-col(:span="24")
          app-label(label="Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?", :required="true")
            validation-provider(rules="required", v-slot="{ errors }", name="Possui georreferenciamento")
              el-radio-group.input.padding(
                v-model="conflito.possuiGeorreferenciamento",
                :class="{'erro' : errors.length}"
              )
                el-radio(:label="true") Sim
                el-radio(:label="false") Não
        el-col.margin(:span="24", v-if="conflito.possuiGeorreferenciamento")
          app-documentos(
            aba="Georreferenciamento",
            :isAnalise="true",
            :idUploadDocumento="'documentoGeorreferenciamento'",
            :titulo="'Georreferenciamento'",
            :maxSize='25000',
            :valid-extensions="extensoes",
            :documentos="documentos",
            :tiposDocumentos="tipoDocumentos",
            :tiposDocumentosObrigatorios="tipoDocumentosObrigatorios",
            :pecasTecnicas="true",
            :observer="this.$refs.conflito",
            @mudaTipo="mudaTipo",
            @setDadosPlanilha="setDadosPlanilha",
            @removedDoc="removeFile",
            @addedDoc="addedDoc"
          )
        el-col.margin(:span="24", v-if="conflito.possuiGeorreferenciamento === false")
          validation-provider(rules="required", v-slot="{ errors }", name="Geometrias")
            mapa-analise-geomensor(
              v-model="conflito.geometrias",
              :localizacoes="conflito.geometrias",
              :tipoCadastro="'NAO_ONEROSO'",
              name="Geometria",
              idMapa="mapaAnaliseGeomensor"
              :errors="errors"
              @shapefileUploaded="setShapefile"
              @shapefileRemoved="removeShapefile"
              :addPonto="true"
            )
    el-row
      el-col.flex(:span="24")
        el-button.btn(type="default", size="small", @click="cancelar")
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(type="success", size="small", @click="salvarCadastro")
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>

<script>
import axios from '@/utils/api'
import { mapActions } from 'vuex'
import MapaAnaliseGeomensor from '@/screens/analise/components/MapaAnaliseGeomensor'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    MapaAnaliseGeomensor,
    AppDocumentos
  },

  mixins: [AppNotificacao],

  props: {
    id: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      extensoes: ['pdf', 'jpeg', 'png', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar', 'jpg', 'doc'],
      tipoDocumentos: [],
      documentos: [],
      tipoDocumentosObrigatorios: [],
      conflito: null
    }
  },
  async mounted () {
    this.conflito = await this.getConflitoById(this.id)
    this.conflito.geometrias = this.conflito.geometrias.map(g => (JSON.parse(g)))
    this.documentos = this.conflito.documentos.map(documento => (
      {
        id: documento.id,
        fileKey: documento.key,
        fileName: documento.nome,
        caminho: documento.caminho,
        tipoDocumento: {
          codigo: documento.tipo.codigo,
          id: documento.tipo.id,
          descricao: documento.tipo.descricao,
          tipo: documento.tipo.codigo
        }
      }
    ))
    this.tipoDocumentos = await this.findTiposDocumentoTipoProcesso({
      url: 'geo',
      tipo: 'NAO_ONEROSO'
    })
    this.tipoDocumentosObrigatorios = [...this.tipoDocumentos]
    this.tipoDocumentos.push({
      id: 334,
      codigo: 'DETALHE_CONFLITO',
      descricao: 'Detalhe do conflito'
    })
  },

  methods: {
    ...mapActions({
      getConflitoById: 'conflito/getConflitoById',
      saveConflito: 'conflito/saveConflito',
      findTiposDocumentoTipoProcesso:
        'tipoDocumento/findTiposDocumentoTipoProcesso'
    }),
    cancelar () {
      this.confirmBox(
        this.$messages.CANCECAR_CONFLITO,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.go(-1)
        },
        () => {}
      )
    },
    salvarCadastro () {
      this.confirmBox(
        this.id ? this.$messages.CADASTRO_CONFIRM_EDIT : this.$messages.CADASTRO_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          const cadastro = {
            ...this.conflito
          }
          cadastro.documentos = this.documentos.map(documento => {
            return {
              id: documento.id,
              caminho: documento.caminho,
              key: documento.fileKey,
              nome: documento.fileName,
              tipo: documento.tipoDocumento
            }
          })
          this.saveConflito(cadastro).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.CONFLITO_FINALIZADO
            )
            this.$router.go(-1)
          })
        },
        () => {}
      )
    },
    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'DRD_DRL':
        case 'RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO':
        case 'ART_TRT':
          this.extensoes = ['pdf']
          break
        case 'RELATORIO_DE_PROCESSAMENTO':
        case 'ARQUIVOS_GNSS':
          this.extensoes = ['zip']
          break
        case 'TABELA_DADOS_CARTOGRAFICOS':
          this.extensoes = ['ods', 'xlsx']
          break
        case 'OUTROS_GEOMENSOR':
          this.extensoes = ['pdf', 'jpeg', 'png', 'jpg', 'doc', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar']
          break
      }
    },
    async setDadosPlanilha (valor) {
      this.conflito.jsonPlanilha = JSON.parse(valor.jsonPlanilha)
    },
    addedDoc () {
    },
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          if (documento.id) {
            axios({
              method: 'DELETE',
              url: `documento/delete`,
              data: documento,
              responseType: 'blob'
            })
              .then(() => {
                this.deleteAnexo(documento)
              })
              .catch(() => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  'Houve um erro ao remover o anexo.'
                )
              })
          } else {
            this.deleteAnexo(documento)
          }
        },
        () => {}
      )
    },
    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.conflito.documentos.indexOf(
          this.conflito.documentos.find(a => a.id === documento.id)
        )
        this.conflito.documentos.splice(index, 1)
      } else {
        const index = this.conflito.documentos.indexOf(
          this.conflito.documentos.find(a => a.key === documento.key)
        )
        this.conflito.documentos.splice(index, 1)
      }
    },
    setShapefile () {
    },
    removeShapefile () {
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin {
    margin: 10px;
  }
  .margin-titulo {
    padding-top: 20px;
    padding-left: 7px;
  }
  .paddingRight {
    position: absolute;
    padding-right: 4px;
    right: 0;
  }
  .flex {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
  }
  .marginLeft {
    margin: 10px;
    margin-top: 0;
  }
  .erro {
    color: red;
  }
  .help.erro {
    font-size: 12px;
  }

  .top-margin {
    margin-top: 10px;
  }

  .info-title {
    font-size: 14px;
    font-weight: bold;
    margin-right: 5px;
  }

  .info-label {
    font-size: 14px;
  }
  .margin-top {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/ShapeConflito.vue